export default "__VITE_ASSET__1Rget5F6__"